<template>
    <div class="mt-2">
        <h4 class="heading-1">
            <span>Informações ao TCU</span>
        </h4>
        <b-list-group>
            <relacao-contrato v-if="mostrarRelacaoContrato"></relacao-contrato>
            <relacao-projeto v-if="mostrarRelacaoProjeto"></relacao-projeto>
            <relacao-contratacao v-if="mostrarRelacaoContratacao"></relacao-contratacao>
            <relacao-licitantes-sgtec v-if="mostrarRelacaoLicitantesSgtec"></relacao-licitantes-sgtec>
            <relacao-bolsistas v-if="mostrarRelacaoLicitantesSgtec"></relacao-bolsistas>
        </b-list-group>
    </div>
</template>

<script>
import RelacaoContrato from '../contratos/RelacaoContrato.vue'
import RelacaoContratacao from '../sgf/RelacaoContratacao.vue'
import RelacaoProjeto from '../sgtec/RelacaoProjeto.vue'
import RelacaoLicitantesSgtec from '../licitantessgtec/RelacaoLicitantesSgtec.vue'
import RelacaoBolsistas from '../bolsistas/RelacaoBolsistas.vue'

export default {
    components: {
        RelacaoContrato,
        RelacaoProjeto,
        RelacaoContratacao,
        RelacaoLicitantesSgtec,
        RelacaoBolsistas
    },
    computed: {
        mostrarRelacaoContrato() {
            return this.$temAcessoView('TCU-REL-01')
        },
        mostrarRelacaoProjeto(){
            return this.$temAcessoView('TCU-REL-02')
        },
        mostrarRelacaoContratacao(){
            return this.$temAcessoView('TCU-REL-03')
        },
        mostrarRelacaoLicitantesSgtec(){
            return this.$temAcessoView('TCU-REL-04')
        },
        mostrarRelacaoBolsistas(){
            return this.$temAcessoView('TCU-REL-04')
        }
    }
}
</script>
